export function formatPhoneNumber(phoneNumber: string) {
	if (!phoneNumber.length) return '';

	// filter everything except '+' and number characters from 0 to 9
	phoneNumber = phoneNumber.replace(/[^+0-9]+/g, '');

	// if number does not start with 0 and number characters from 1 to 9
	if (!phoneNumber.startsWith('0') && phoneNumber.match(/[1-9]+/g))
		phoneNumber = '+' + phoneNumber;

	if (!phoneNumber.startsWith('00') && phoneNumber.startsWith('0') && phoneNumber.length > 1) {
		phoneNumber = '+' + phoneNumber;
	}

	// change '00' to '+'
	if (phoneNumber.startsWith('00')) phoneNumber = phoneNumber.replace(/^.{2}/g, '+');

	// validate number
	if (phoneNumber.startsWith('+')) {
		// filter everything except numbers
		phoneNumber = phoneNumber.replace(/[^0-9]+/g, '');
		// match every 0 from the begining until 1-9 is found and remove them
		phoneNumber = phoneNumber.replace(/[^1-9]*/, '');
		// add + sign
		phoneNumber = `+${phoneNumber}`;
	}

	return phoneNumber;
}
